/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Emailconfirmed1Inputs */

const en__field_emailconfirmed1 = /** @type {(inputs: _Field_Emailconfirmed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail confirmed`)
};

const de__field_emailconfirmed1 = /** @type {(inputs: _Field_Emailconfirmed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail bestätigt`)
};

/**
* | output |
* | --- |
* | "E-Mail confirmed" |
*
* @param {_Field_Emailconfirmed1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_emailconfirmed1 = /** @type {((inputs?: _Field_Emailconfirmed1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Emailconfirmed1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_emailconfirmed1(inputs)
	return de__field_emailconfirmed1(inputs)
});
export { _field_emailconfirmed1 as "_field_emailConfirmed" }